module.exports = __webpack_public_path__ + "assets/img/communicationPlatform.2d912478.png";